import React from 'react';
import { Select2 } from "select2-react-component";

const dropDownWithSearch = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);
	const classname = fieldDetail.classname || '';
	const isMandatory = classname.indexOf('mandatory') !== -1;
	// console.log('dropDownWithSearch',props.fieldKey,fieldDetail.value);
	return (
		fieldDetail.options.length > 0 ?
		<div className={isMandatory ? 'mandatory' : undefined}>
			<Select2 data={fieldDetail.options}
	            value={fieldDetail.value}
	            minCountForSearch ={1}
	            update={value => props.changed(value,props.fieldKey)}
	            disabled={fieldDetail.disabled ? fieldDetail.disabled : false}
	            >
	        </Select2>
        </div> : 
        <select className={fieldDetail.classname} name={props.fieldKey} onChange={props.changed} value={fieldDetail.value}>
    		<option value=''></option>
     	</select>
	);
}

export default dropDownWithSearch;
